import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mockData';
import { AnimateOnScroll } from '../hooks/useScrollAnimation';

const TestimonialsSection = () => {
  return (
    <section
      id="testimonials"
      className="py-20 md:py-32 bg-[#08080a] relative border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <AnimateOnScroll>
          <div className="text-center mb-16">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white font-bold uppercase tracking-tight mb-4 italic">
              Straight from the <span className="gold-gradient">Chair</span>
            </h2>
            <p className="text-zinc-400 text-base md:text-lg max-w-2xl mx-auto">
              Don&apos;t take our word for it. Here&apos;s what our clients have to say.
            </p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <AnimateOnScroll key={testimonial.name} delay={index * 100}>
              <div className="bg-card border border-white/5 rounded-3xl p-8 flex flex-col hover:-translate-y-2 transition-transform duration-300 shadow-lg h-full">
                {/* Stars */}
                <div className="flex text-primary mb-6 gap-1">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-current" />
                  ))}
                </div>

                {/* Quote */}
                <p className="text-zinc-300 mb-8 flex-grow leading-relaxed">
                  &ldquo;{testimonial.text}&rdquo;
                </p>

                {/* Author */}
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center font-heading font-bold text-white italic">
                    {testimonial.initial}
                  </div>
                  <div>
                    <p className="font-heading font-bold text-white italic">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-primary font-semibold uppercase tracking-wider">
                      {testimonial.label}
                    </p>
                  </div>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
